import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from '../actions/new-wdocument.actions'
import { actions as contractorActions } from '../actions/contractor.actions'
import { DatePicker, Col, Row, Form, Modal, Select, Input, Upload, Icon, Radio } from 'antd'
import { dspxGetChildrens, dspxGetChildrensContractor } from '../helpers/dspx-utils'
import moment from 'moment'
import ContractorRef from '../components/contractor-ref';
import { fromDateStr } from '../helpers/utcDate'

const NewDocumentForm = Form.create()(
	class extends React.Component {

		constructor(props) {
			super(props)

			this.state = {
				fileList: []
			}
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;

			const { getFieldDecorator } = form;	

			return (
				<Modal
					width={520}
					visible={visible}
					title="Добавить документ"
					okText="Добавить"
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">

						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Файл документа">
									{getFieldDecorator('docfile', {
										initialValue: null,
										rules: [{ required: true, message: 'Пожалуйста прикрепите файл документа' }]
									})(
										<Upload.Dragger
											//name='file'
											fileList={this.state.fileList}
											multiple={false}
											beforeUpload={(file) => {
												this.setState(({ fileList }) => ({
													fileList: [file]
												}));
												return false;
											}}
											onRemove={(file) => {
												this.setState(({ fileList }) => {
													const index = fileList.indexOf(file);
													const newFileList = fileList.slice();
													newFileList.splice(index, 1);
													return {
														fileList: newFileList,
													};
												});
											}}>
											<Icon type="file-add" theme="outlined" /> перетащите файл документа сюда, или нажмите, чтобы выбрать
									</Upload.Dragger>)}
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={8}>
							<Col span={5}>
							<Form.Item label="Номер">
									{getFieldDecorator('docNumber')(
										<Input  />)}
								</Form.Item>										
							</Col>
							<Col span={6}>
								<Form.Item label="Дата">
									{getFieldDecorator('docMoment', {
										initialValue: moment()
									})(
										<DatePicker style={{width:115}} allowClear={false} format='DD.MM.YYYY' />)}
								</Form.Item>
							</Col>
							<Col span={13}>
								<Form.Item style={{  marginTop: '29px', marginLeft: 10 }}>
									{getFieldDecorator('direction', { initialValue: 'in' })(
										<Radio.Group buttonStyle="solid">
											<Radio.Button value="in"><Icon type='download'/> Входящий</Radio.Button>
											<Radio.Button value="out"><Icon type='upload'/> Исходящий</Radio.Button>
										</Radio.Group>
									)}
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={16}>
							<Col span={10}>
								<Form.Item label="Тип документа">
									{getFieldDecorator('typeId', {
										rules: [{ required: true, message: 'Пожалуйста, укажите тип документа' }]
									})(
										<Select
											showSearch
											placeholder="тип документа"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
											{dspxGetChildrens(fprops.listDocumentType)}
										</Select>)}
								</Form.Item>
							</Col>
							<Col span={14}>
								<Form.Item label="Наименование">
									{getFieldDecorator('name', { 
										rules: [{ required: true, message: 'Пожалуйста введите наименование документа' }]
									})(
										<Input />)}
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={8} align='middle'>
							<Col span={22}>
								<Form.Item label="Организация (контрагент)">
									{getFieldDecorator('orgId', fprops.contractorId ? { initialValue: ''+fprops.contractorId ,
										rules: [{ required: true, message: 'Пожалуйста, укажите организацию отправителя/получателя документа' }]
									} : { initialValue: undefined, 
										rules: [{ required: true, message: 'Пожалуйста, укажите организацию отправителя/получателя документа' }]})(
										<Select
											showSearch
											placeholder="организация"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
											{dspxGetChildrensContractor(fprops.contractors)}
										</Select>)}
								</Form.Item>
								</Col>
								<Col span={2}>
									<ContractorRef
										style={{ paddingTop: 28 }}
										addCreatedOrg={(createdOrgId) => {
											if (!form.getFieldValue(`orgId`)) {
												form.setFieldsValue({ orgId: `${createdOrgId}` });
											}
										}}
									/>
								</Col>								
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class NewDocumentContainer extends Component {
	state = {
		confirmLoading: false,
	};

	componentDidMount() {
		this.props.dispatch(actions.fetchDocumentTypeList());
		this.props.dispatch(contractorActions.fetchContractorList());
	}


	handleCancel = () => {
		const form = this.formRef.props.form;
		form.resetFields();
		this.props.dispatch(actions.closeNewDocumentModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;

		form.validateFields(async (err, values) => {

			if (err) return;

			const v = { ...values, file: this.formRef.state.fileList[0], 
				docDate: fromDateStr(values.docMoment) 
			}

			const attachments = this.formRef.state.fileList;

			if (typeof this.props.onAddDocument === 'function') {
				this.setState({
					confirmLoading: true,
				});

				await this.props.onAddDocument(this.props.request, v);

				this.setState({
					confirmLoading: false,
				});
			} else {
				this.props.dispatch(actions.postDocument(v, attachments, this.props.request));
			}

			form.resetFields();
			this.formRef.state.fileList = [];
			this.props.dispatch(actions.closeNewDocumentModal())
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {
		return (
			<NewDocumentForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.newDocumentModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
//				onAddNewContractor={this.handleAddNewContractor}
				fprops={this.props}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { newWDocumentStore } = state;
	const { contractors } = state.contractorStore;
	return {...newWDocumentStore, contractors };
}

export default connect(mapStateToProps)(NewDocumentContainer);